import OTPAdornment from './OTPAdornment';

export default OTPAdornment;
